/** animate.css — used with global import in `src/index.tsx` */
export const fadeInUp =
  'animate__animated animate__fadeInUp animate__faster';
export const fadeInDown =
  'animate__animated animate__fadeInDown animate__faster';
